import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-09a091c5")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 上传文件 ")
const _hoisted_2 = { class: "upload-list" }
const _hoisted_3 = { class: "upload-list-item-btns" }
_popScopeId()

import {
  UploadOutlined,
  UpOutlined,
  DownOutlined,
  DeleteOutlined,
  CheckOutlined
} from '@ant-design/icons-vue'
import { uploadFileToOss } from '@/utils/oss'
import { message } from 'ant-design-vue'
import { ref, watch, onBeforeMount } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  formData: {
    type: Object,
    default: () => { return {} }
  }
},
  emits: ['onChange'],
  setup(__props, { emit }) {

const props = __props


// 多声部相关操作
const fileListMultiVoice = ref<{
    uid: any,
    name: string,
    status: 'uploading' | 'done' | 'removed' | 'error',
    percent: number,
    url?: string
  }[]>([])

watch(() => fileListMultiVoice.value, () => {
  const formData = props.formData
  formData.extend_data.multi_part_song = fileListMultiVoice.value.filter(v => !['removed', 'error'].includes(v.status) && v.url).map(v => v.url)
  emit('onChange', formData)
})

const num2zh = (num: number) => {
  const _s = '一二三四五六七八九十'
  return num < _s.length ? _s.substring(num, num + 1) : num + 1
}

const updateFileListMultiVoice = (uid:any, data:any) => {
  for (const record of fileListMultiVoice.value) {
    if (record.uid === uid) {
      Object.assign(record, data)
    }
  }
  fileListMultiVoice.value = [...fileListMultiVoice.value]
}
const getRecordIndexByUid = (uid: string) => {
  for (const index in fileListMultiVoice.value) {
    const record = fileListMultiVoice.value[index]
    if (record.uid === uid) {
      return parseInt(index)
    }
  }
  return -1
}
// 声部歌曲上下调整，后续可能还要加一个emit进去，或者说watch fileListMultiVoice会不会更好一点
const handleItemMove = (position:string) => (uid:string) => {
  const length = fileListMultiVoice.value.length
  for (const index in fileListMultiVoice.value) {
    const _i = parseInt(index)
    const record = fileListMultiVoice.value[_i]
    if (record.uid === uid) {
      let to = _i
      if (position === 'down') {
        to = (_i + 1 + length) % length
        while (['removed', 'error'].includes(fileListMultiVoice.value[to].status)) {
          to = (to + 1 + length) % length
        }
      } else if (position === 'up') {
        to = (_i - 1 + length) % length
        while (['removed', 'error'].includes(fileListMultiVoice.value[to].status)) {
          to = (to - 1 + length) % length
        }
      }
      fileListMultiVoice.value[_i] = fileListMultiVoice.value[to]
      fileListMultiVoice.value[to] = record
      break
    }
  }
  fileListMultiVoice.value = [...fileListMultiVoice.value]
}
// 不忽视被移除与错误的记录
const _handleItemMove = (position:string) => (uid:string) => {
  const length = fileListMultiVoice.value.length
  for (const index in fileListMultiVoice.value) {
    const _i = parseInt(index)
    const record = fileListMultiVoice.value[_i]
    if (record.uid === uid) {
      let to = _i
      if (position === 'down') {
        to = (_i + 1 + length) % length
      } else if (position === 'up') {
        to = (_i - 1 + length) % length
      }
      fileListMultiVoice.value[_i] = fileListMultiVoice.value[to]
      fileListMultiVoice.value[to] = record
      break
    }
  }
  fileListMultiVoice.value = [...fileListMultiVoice.value]
}

const handleUploadMultiVoice = async e => {
  const file = e.file
  const uid = file.uid
  const name = file.name.replaceAll(' ', '')
  fileListMultiVoice.value.splice(fileListMultiVoice.value.reduce((v: number, c: any) => !['removed', 'error'].includes(c.status) ? v + 1 : v, 0), 0, {
    uid,
    name,
    status: 'uploading',
    percent: 0,
    url: undefined
  })
  try {
    message.info(`开始上传 ${name}`)
    const responseData: any = await uploadFileToOss(file, true, (e) => {
      updateFileListMultiVoice(uid, { percent: e })
    }, name)
    message.success(`${name} 上传成功`)
    updateFileListMultiVoice(uid, { status: 'done', url: responseData.url })
  } catch (e) {
    console.error(e)
    message.error(`${name} 上传失败`)
    message.error(`报错：${e}。请联系相关工作人员解决~`)
    updateFileListMultiVoice(uid, { status: 'error' })
    while (getRecordIndexByUid(uid) !== fileListMultiVoice.value.length - 1 && fileListMultiVoice.value[getRecordIndexByUid(uid) + 1].status !== 'error') {
      _handleItemMove('down')(uid)
    }
  }
}

const handleItemRemove = (uid:string) => {
  // 以下是直接删除的版本
  for (const index in fileListMultiVoice.value) {
    const _i = parseInt(index)
    const record = fileListMultiVoice.value[_i]
    if (record.uid === uid) {
      fileListMultiVoice.value.splice(_i, 1)
      break
    }
  }
  fileListMultiVoice.value = [...fileListMultiVoice.value]
}

const findFileNameFromUrl = (url: string): string | undefined => {
  const regex = /\/([^/]+\.mp3)/
  const match = url.match(regex)
  if (match) {
    const decodedString = decodeURIComponent(match[1].split('-vc')[0])
    return decodedString
  } else {
    return undefined
  }
}

onBeforeMount(() => {
  fileListMultiVoice.value = [...(props.formData?.extend_data?.multi_part_song ?? [])].map((v, index) => ({
    uid: Math.random(),
    name: findFileNameFromUrl(v) ?? `原第${num2zh(index)}声部`,
    status: 'done',
    percent: 100,
    url: v
  }))
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_upload, {
      "file-list": fileListMultiVoice.value,
      "onUpdate:file-list": _cache[1] || (_cache[1] = ($event: any) => (fileListMultiVoice.value = $event)),
      customRequest: handleUploadMultiVoice,
      "show-upload-list": false && {
      showDownloadIcon: false,
      showRemoveIcon: true
    },
      accept: ".mp3",
      disabled: !props.formData.ori_file_url
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "multi-voice-upload-btn",
          disabled: !props.formData.ori_file_url
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UploadOutlined)),
            _hoisted_1
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createElementVNode("span", {
          class: "red-text",
          onClick: _cache[0] || (_cache[0] = e=>e.stopPropagation())
        }, "声部顺序按照列表顺序进行上传")
      ]),
      _: 1
    }, 8, ["file-list", "disabled"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileListMultiVoice.value, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "upload-list-item",
          key: item.uid
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["upload-list-item-before", item.status])
          }, _toDisplayString(item.status !== 'error' ? `第${num2zh(index)}声部` : '上传失败'), 3),
          _createElementVNode("span", {
            class: _normalizeClass(item.status)
          }, _toDisplayString(item.name), 3),
          _withDirectives(_createVNode(_unref(CheckOutlined), { class: "upload-list-item-success" }, null, 512), [
            [_vShow, item.status === 'done']
          ]),
          _createElementVNode("span", _hoisted_3, [
            (item.status === 'uploading')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["upload-list-item-process", item.status])
                }, "上传进度：" + _toDisplayString(item.percent) + "%", 3))
              : _createCommentVNode("", true),
            (item.status !== 'error')
              ? (_openBlock(), _createBlock(_unref(UpOutlined), {
                  key: 1,
                  class: _normalizeClass(["upload-list-item-icon", item.status]),
                  onClick: ($event: any) => (handleItemMove('up')(item.uid))
                }, null, 8, ["class", "onClick"]))
              : _createCommentVNode("", true),
            (item.status !== 'error')
              ? (_openBlock(), _createBlock(_unref(DownOutlined), {
                  key: 2,
                  class: _normalizeClass(["upload-list-item-icon", item.status]),
                  onClick: ($event: any) => (handleItemMove('down')(item.uid))
                }, null, 8, ["class", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(DeleteOutlined), {
              class: _normalizeClass(["upload-list-item-icon", item.status]),
              onClick: ($event: any) => (handleItemRemove(item.uid))
            }, null, 8, ["class", "onClick"])
          ])
        ], 512)), [
          [_vShow, item.status !== 'removed']
        ])
      }), 128))
    ])
  ], 64))
}
}

})